import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  tracking?: string;
  children: ReactNode | Array<ReactNode>;
}

const ContainerLayout = ({ children, tracking }: Props) => {
  return (
    <div
      className={classNames('flex min-h-screen flex-col px-5 pb-10 md:px-10', {
        [tracking]: tracking !== null,
      })}
    >
      <div className="container mr-auto flex flex-col gap-y-5 px-0 pb-16 md:gap-y-10">{children}</div>
    </div>
  );
};

export { ContainerLayout };
